module.exports = __webpack_public_path__ + "static/media/lastImage.a5b1579c.jpg";